import React, { useState } from 'react';
import Slider from 'react-slick';
import FeaturedImage from '../FeaturedImage';
import CloseIcon from '../../assets/images/icons/CloseIcon.svgr';

function staff(props) {
    const {
        post,
        postType,

        replaceSelected,
    } = props;

    const [modalVisible, setModalVisible] = useState(false);
    const [tabKey, setTabKey] = useState('professional');

    let categories;
    let categoryItems;
    let featuredImage;
    let modal;

    function toggleModal(e) {
        e.preventDefault();
        setModalVisible(!modalVisible);
    }
    function closeModal(e) {
        e.preventDefault();
        setModalVisible(false);
    }

    function modalActiveClass() {
        let modalClassString = '';

        if (modalVisible) {
            modalClassString = 'modal-active';
            document
                .querySelector('html')
                .classList.add(modalClassString, 'modal-team');
        } else {
            document
                .querySelector('html')
                .classList.remove('modal-active', 'modal-team');
        }

        return modalClassString;
    }

    window.addEventListener('orientationchange', () => {
        setModalVisible(false);
        document
            .querySelector('html')
            .classList.remove('modal-active', 'modal-team');
    });

    window.addEventListener('keydown', function (e) {
        if (e.keyCode == 27) {
            closeModal(e);
        }
    });

    if (
        post.hasOwnProperty('_embedded') &&
        post._embedded.hasOwnProperty('wp:featuredmedia')
    ) {
        featuredImage = (
            <a
                onClick={(e) => {
                    toggleModal(e);
                }}
                className="eight29-featured-image"
            >
                <figure>
                    <FeaturedImage
                        imageSize={'team-thumb'}
                        image={post._embedded['wp:featuredmedia']}
                        srcset={post.featured_image_srcset}
                    ></FeaturedImage>
                </figure>
            </a>
        );
    }

    if (
        post.hasOwnProperty('_embedded') &&
        post._embedded.hasOwnProperty('wp:term')
    ) {
        categories = post._embedded['wp:term'][0];
    }

    if (categories) {
        categoryItems = categories.map((category, index) => {
            return (
                <a
                    key={category.id}
                    onClick={() => {
                        replaceSelected(category.id, category.taxonomy);
                    }}
                >
                    {category.name}
                </a>
            );
        });
    }

    let iconLinkedin = '';

    if (post.acf.team_linkedin_url) {
        iconLinkedin = (
            <a
                target="_blank"
                rel="noreferrer"
                href={post.acf.team_linkedin_url}
                className="eight29-post-social-media__item-wrap eight29-post-social-media__item--linkedin"
            >
                <span className="eight29-post-social-media__item-icon">
                    <svg
                        width="15"
                        height="15"
                        viewBox="0 0 15 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M3.30593 14.7692H0.243956V4.90857H3.30593V14.7692ZM1.7733 3.56349C0.794176 3.56349 0 2.75248 0 1.77334C7.00813e-09 1.30302 0.186829 0.851963 0.519387 0.519398C0.851944 0.186833 1.30299 0 1.7733 0C2.2436 0 2.69465 0.186833 3.02721 0.519398C3.35976 0.851963 3.54659 1.30302 3.54659 1.77334C3.54659 2.75248 2.75209 3.56349 1.7733 3.56349ZM14.7659 14.7692H11.7105V9.96912C11.7105 8.82514 11.6875 7.35808 10.1186 7.35808C8.52659 7.35808 8.28264 8.60096 8.28264 9.8867V14.7692H5.22396V4.90857H8.16066V6.25366H8.20352C8.61231 5.47891 9.61088 4.66131 11.1007 4.66131C14.1996 4.66131 14.7692 6.70202 14.7692 9.35263V14.7692H14.7659Z"
                            fill="#163D9B"
                        />
                    </svg>
                </span>
            </a>
        );
    }

    let iconEmail = '';

    if (post.acf.team_email) {
        iconEmail = (
            <a
            target="_blank"
            rel="noreferrer"
            href={`mailto:${post.acf.team_email}`}
            className="eight29-post-social-media__item-wrap eight29-post-social-media__item--email"
        >
            <span className="eight29-post-social-media__item-icon">
                <svg
                    width="14"
                    height="12"
                    viewBox="0 0 14 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M1.66683 0.666748H12.3335C13.0668 0.666748 13.6668 1.26675 13.6668 2.00008V10.0001C13.6668 10.7334 13.0668 11.3334 12.3335 11.3334H1.66683C0.933496 11.3334 0.333496 10.7334 0.333496 10.0001L0.340163 2.00008C0.340163 1.26675 0.933496 0.666748 1.66683 0.666748ZM7.00016 6.66675L12.3335 3.33341V2.00008L7.00016 5.33341L1.66683 2.00008V3.33341L7.00016 6.66675Z"
                        fill="#163D9B"
                    />
                </svg>
            </span>
        </a>
        );
    }

    let phoneNumber = '';

    if (post.acf.team_link_number) {
        phoneNumber = (
        <div className="eight29-post-ext"><a href={`tel:${post.acf.team_link_number}`} className="eight29-post-link-number">EXT. {post.acf.team_ext}</a></div>
        );
    }


    const postMeta = (
        <div className="eight29-post-meta">
            <div className="eight29-post-social-media">
                {iconLinkedin}
                {iconEmail}
            </div>
            {phoneNumber}
        </div>
    );

    if (modalVisible) {
        const toggleTab = (id) => {
            setTabKey(id);
        };

        const TabLink = (props) => {
            const { id, title } = props;
            const activeClass = tabKey === id ? 'active' : '';

            return (
                <li
                    className={`tabs__link ${activeClass}`}
                    onClick={() => toggleTab(id)}
                >
                    <a className="tabs_link--inner">{title}</a>
                </li>
            );
        };

        const TabContent = (props) => {
            const { id, content } = props;
            const activeClass = tabKey === id ? 'active' : '';

            return (
                <div
                    key={id}
                    className={`tabs__tab-content ${activeClass}`}
                    data-tab-id={`#team-modal-${id}`}
                    dangerouslySetInnerHTML={{
                        __html: content,
                    }}
                ></div>
            );
        };

        // Render either single image or gallery slider

        let featuredImageGallery;

        if (post.gallerySlides.length > 0) {
            // Slick slider settings
            const settings = {
                dots: true,
                infinite: false,
                speed: 500,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
            };

            const gallerySlides = post.gallerySlides.map((slide, index) => {
                return (
                    <figure key={index + 1}>
                        <FeaturedImage
                            imageSize={'team-thumb'}
                            image={[slide.featuredMedia]}
                            srcset={slide.featuredMedia.srcset}
                        ></FeaturedImage>
                    </figure>
                );
            });

            gallerySlides.unshift(<figure key={0}>
                <FeaturedImage
                    imageSize={'team-thumb'}
                    image={post._embedded['wp:featuredmedia']}
                    srcset={post.featured_image_srcset}
                ></FeaturedImage>
            </figure>);

            //console.log(gallerySlides);

            featuredImageGallery = (
                <Slider {...settings}>{gallerySlides}</Slider>
            );
        } else {
            featuredImageGallery = (
                <figure>
                    <FeaturedImage
                        imageSize={'team-thumb'}
                        image={post._embedded['wp:featuredmedia']}
                        srcset={post.featured_image_srcset}
                    ></FeaturedImage>
                </figure>
            );
        }

        modal = (
            <div className="eight29-post-modal">
                <button
                    className="eight29-post-modal-toggle eight29-post-modal-close"
                    onClick={(e) => {
                        toggleModal(e);
                    }}
                >
                    <CloseIcon></CloseIcon>
                </button>
                <div className="eight29-post-modal-body">
                    <div className="eight29-post-modal-content-left">
                        <h4 className="eight29-post-title">
                            {post.title.rendered}
                        </h4>
                        <div className="eight29-post-job-title">
                            {post.acf.team_job_title}
                        </div>
                        <div className="tabs">
                            <div className="tabs__tab-content-wrapper">
                                <TabContent
                                    key="professional"
                                    id="professional"
                                    content={post.acf.team_proffesional_info}
                                ></TabContent>
                                <TabContent
                                    key="personal"
                                    id="personal"
                                    content={post.acf.team_personal_info}
                                ></TabContent>
                            </div>
                            <div className="tabs__link-list-wrapper">
                                <ul className="tabs__link-list">
                                    <TabLink
                                        key="professional"
                                        id="professional"
                                        title="Professional"
                                    ></TabLink>
                                    <TabLink
                                        key="personal"
                                        id="personal"
                                        title="Personal"
                                    ></TabLink>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="eight29-post-modal-content-right">
                        <div className="eight29-post-modal-gallery">
                            {featuredImageGallery}
                        </div>
                        {postMeta}
                    </div>
                </div>
            </div>
        );
    }

    return (
        <article
            id={`${postType}-${post.id}`}
            className={`eight29-post eight29-post-card eight29-post-staff ${modalActiveClass()}`}
        >
            {featuredImage}

            <div className="eight29-post-body">
                <h4 className="eight29-post-title">
                    <a
                        onClick={(e) => {
                            toggleModal(e);
                        }}
                        dangerouslySetInnerHTML={{
                            __html: post.title.rendered,
                        }}
                    ></a>
                </h4>

                <div className="eight29-post-job-title">
                    {post.acf.team_job_title}
                </div>
                {postMeta}
            </div>
            {modal}
        </article>
    );
}

export default staff;
